import { useQuery } from '@tanstack/react-query';
import { getAutomationRecipes } from '../../services/automations';
import { AUTOMATION_RECIPE_DISPLAY } from '../../constants/automations';
import { AutomationRecipe } from '../../types/marketing/automations';

function useGetAutomationRecipes() {
  const { data, isLoading, isError } = useQuery<AutomationRecipe[]>({
    queryKey: ['automation-recipes'],
    queryFn: async () => {
      const configs = await getAutomationRecipes();
      return configs.map(config => ({
        ...config,
        ...AUTOMATION_RECIPE_DISPLAY[config.id],
      }));
    },
    staleTime: Infinity,
  });

  return { data, isPending: isLoading, isError };
}

export default useGetAutomationRecipes;
